<template>
  <v-dialog v-model="dialogDettaglioFattura" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-btn icon dark @click="dialogDettaglioFattura = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Documento {{idDocumento}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialogDettaglioFattura = false">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>     
      <header-fattura :locDocumento="locDocumento" :trigger="trigger"/>
      <body-fattura :locDocumento="locDocumento" :trigger="trigger" />
      <footer-fattura :locDocumento="locDocumento" :trigger="trigger"/>
    </v-card>
  </v-dialog>
</template>

<script>
  import HeaderFattura from './header.vue'
  import BodyFattura from './bodyTable.vue'
  import FooterFattura from './footer.vue'
  import documenti from '@/services/documentiService.js'
  export default {
    components: {
      HeaderFattura,
      BodyFattura,
      FooterFattura
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: String
    },
    data () {
      return {
        // idDocumento: 'PF2022/000009',
        locDocumento: null,
        dialogDettaglioFattura: false,
        trigger: 1
      }
    },
    async mounted() {
      if (this.idDocumento) {
        this.locDocumento = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
      }
      this.dialogDettaglioFattura = this.showDialog
    },
    watch: {
      async showDialog(value) {
        if (value) {
          await this.refresh()
/*           this.dialogDettaglioFattura = true
          this.locDocumento = await documenti.getDocumento(this.idDocumento) */
        }
      }
    },
    methods: {
      async refresh() {
        this.dialogDettaglioFattura = true
        this.locDocumento = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
        this.trigger++
      },
      completaAppoggio() {
        let itm = this.locDocumento
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm.anagrafica, 'cliente', '') || _.get(itm.anagrafica, 'fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      }      
    }
  }
</script>